<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <span v-if="tenant == 'sbpps'">
        <v-card class="box no-display" >
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
            <v-toolbar flat class="toolbar" dense justify="center">
                <v-toolbar-title align="center">
                    <strong>
                        Pre Primary Student Report Cards
                    </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row dense justify="center">
                  <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required color="#0F2027" v-model="org" :items="org_list" item-text="name" return-object label="Organization" outlined @click="clear()" @change="getAy()"></v-autocomplete>
                </v-col>
                     <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required color="#0F2027" v-model="ay" :items="academic_year_list" item-text="ay" return-object label="Academic Year" @click="clear()"  @change="getStandard();" outlined></v-autocomplete>
                </v-col>
                 <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete v-model="registration_no" rounded color="#0F2027" :items="stud_list" label="Select Student" item-text="name" item-value="registration_number"  @change="addtomarksheet" @click="show = false"  outlined dense  />
                </v-col>
                 <v-col cols="12" sm="2" md="2" v-if="ay && org &&  registration_no">
                    <v-btn class="mt-6 button" @click="getreport()">Fetch / Generate</v-btn>
                </v-col>
            </v-row>
        </v-card>
        <span v-if="show == true">
        <learner-marksheet-admin :org="org.id"></learner-marksheet-admin> 
        </span>
        </span>
        <span v-else>
            <v-card class="box no-display" >
            <strong> <center> <h1> Under Development !!! </h1>  </center> </strong>
            </v-card>
        </span>
        
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import LearnetMarksheetOfAdmin from "../../Examination/Admin/PrePrimaryMarksheet";
    export default {
         components:{
            'learner-marksheet-admin':LearnetMarksheetOfAdmin
        },
        data() {
            return {
                all_toggle: false,
                loader: false,
                overlay: false,
                color: "",
                snackbar: false,
                search: null,
                snackbar_msg: null,
                fees_structure_data: null,
                current_academic_year: null,
                stream: null,
                header: null,
                standard_list: null,
                dision_list: null,
                org_list: null,
                display_data: false,
                org_data_list: [],
                division_list: [],
                dialog: false,
                org_data: [],
                fetch_loader: false,
                header_list: [],
                org:null,
                show:false,
                std_id:null,
                sem_id:null,
                sem_list:[],
                ay:null,
                academic_year_list: null,
                stud_list:[],
                registration_no:null,
                tenant:null,
            };
        },
         created() {
            this.tenant = localStorage.getItem("EPS-tenant");
        },
        watch: {
        
        },
        methods: {
             getreport() {
                this.$store.commit("setay", this.ay.ay_id);
                this.$store.commit("setreg_no", this.registration_no);
                this.show = true;
             },
             addtomarksheet(){
                const data = {
                    lid: this.registration_no,
                    ay: this.ay.ay_id,
                    org : this.org.id
                };
                axios
                    .post("/Examination/getpreprimaryStudentReport", data)
                    .then((res) => {
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        this.fetch_loader = false;
                    })
                    .finally(() => {});
            },
            clear() {
                this.org_data_list = [];
            },
            getAy() {
                const data = {
                    org: this.org.id,
                };
                axios
                    .post("/Management/getAy", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.academic_year_list = res.data.academic_year_list;
                          //  this.standard_list = res.data.standard_list;
                            this.sem_list = res.data.sem_list
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!");
                    })
                    .finally(() => {
                        //close loader
                    });
            },
            getStandard() {
                 const data = {
                    org: this.org.id,
                    ay: this.ay.ay,
                };
                  axios
                    .post("/Management/getLearner", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.stud_list = res.data.stud_list_pp
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!");
                    })
                    .finally(() => {
                        //close loader
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                axios
                    .post("/Management/getOrg_without_all")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.org_list = res.data.org_list;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!");
                    })
                    .finally(() => {
                        //close loader
                    });
            },
        },
        mounted() {
            this.onload();
        },
    };
</script>
<style scoped>
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .btn-css {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #fff !important;
        text-decoration: underline;
        color: #0f2027 !important;
        text-align: center;
    }

    .btn-css:hover {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #ffff !important;
        color: #0f2027 !important;
        text-decoration: underline;
        text-align: center;
    }
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
        font-size: small;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }
    @media print {
    
        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }
       
    }
</style>
